// src/components/sections/hero.jsx
import React from 'react';
import { useTranslation } from '../../i18n';
import SectionTag from '../common/SectionTag';

// ✅ CORRIGÉ : Le composant s'appelle Hero (pas Devise)
const Hero = () => {
  const { t } = useTranslation();

  const cards = [
    {
      icon: '🔥',
      titleKey: 'devise_will_title',
      descKey: 'devise_will_desc',
      color: 'border-ofd-yellow',
      bg: 'bg-ofd-yellow/10'
    },
    {
      icon: '🤝',
      titleKey: 'devise_solidarity_title',
      descKey: 'devise_solidarity_desc',
      color: 'border-ofd-red',
      bg: 'bg-ofd-red/10'
    },
    {
      icon: '🌱',
      titleKey: 'devise_dev_title',
      descKey: 'devise_dev_desc',
      color: 'border-ofd-blue',
      bg: 'bg-ofd-blue/10'
    },
  ];

  return (
    <section className="bg-ofd-slate px-4 md:px-10 py-20 text-center relative overflow-hidden">
      <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-[#003F88] via-[#F5C300] to-[#C8102E]" />
      
      <div className="max-w-7xl mx-auto relative">
        <SectionTag>{t('devise_tag')}</SectionTag>
        <h2 className="font-playfair text-3xl md:text-4xl font-bold text-white mb-0">
          {t('devise_title')}
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-12">
          {cards.map((card, index) => (
            <div
              key={index}
              className={`p-10 rounded-xl ${card.bg} border-t-4 ${card.color} transition-all duration-300 hover:transform hover:-translate-y-2 hover:shadow-2xl backdrop-blur-sm`}
            >
              <div className="text-4xl mb-4">{card.icon}</div>
              <h3 className={`font-playfair text-2xl font-bold mb-3 ${
                index === 0 ? 'text-ofd-yellow' : 
                index === 1 ? 'text-ofd-red' : 
                'text-ofd-blue'
              }`}>
                {t(card.titleKey)}
              </h3>
              <p className="text-white/60 text-sm leading-relaxed">{t(card.descKey)}</p>
            </div>
          ))}
        </div>
      </div>
      
      <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-[#003F88] via-[#F5C300] to-[#C8102E]" />
    </section>
  );
};

export default Hero; // ✅ Exporte Hero